export default __webpack_public_path__ + "static/NotoSans-Regular-fa11626fafb16c629d2c58b0ff6fbd38.ttf";